import { render, staticRenderFns } from "./CargoCrudRotogramEdit.vue?vue&type=template&id=098815b5"
import script from "./CargoCrudRotogramEdit.vue?vue&type=script&lang=js"
export * from "./CargoCrudRotogramEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports